import type { RootState } from "../store"

export const supportSelector = (state: RootState) => state.support
